import { VoteMethod } from '../types';

const { PHYSICALLY_PRESENT, REMOTELY_PRESENT } = VoteMethod;

export const isCoOwnerPresent = (
  voteMethod: string,
): voteMethod is VoteMethod.PHYSICALLY_PRESENT | VoteMethod.REMOTELY_PRESENT =>
  [PHYSICALLY_PRESENT, REMOTELY_PRESENT].includes(voteMethod as VoteMethod);
